import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService, ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioQualificacaoUpdateDesqualificado } from '../desqualificado';
import { NegocioQualificacaoSearch } from '../negocio-qualificacao-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioQualificacaoDesqualificadoHttpService {
    private pathApi: string;

    constructor(private authService: AuthService,
                configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negocioqualificacao`;
    }

    /** Atualiza os dados da desqualificação de um negócio */
    update(update: NegocioQualificacaoUpdateDesqualificado): Observable<NegocioQualificacaoSearch> {
        return this.customHttp.put<NegocioQualificacaoSearch>(`${this.pathApi}/${update.idNegocio}/desqualificado`, update);
    }
}
